import editorAction from "../actions/editorAction";
import { useTreeStateContext } from "../contexts/TreeContext";
import BlockContainerAction from '../actions/blockContainerAction';
// Warning useCtrlKey is activate with shiftKey
function useCtrlKey() {
    const { setCtrlKey } = editorAction();

    const { ctrlKey, shiftKey } = useTreeStateContext();
    
    const onKeyDown = (e) => {
        //console.log('toto');
        if (e.ctrlKey == false) return;
        setCtrlKey(true)
        if(shiftKey) document.querySelectorAll('.block').forEach(block => block.classList.add('ctrlKey'))
        // Messy fix for optimize rendering on block for multiple selection
        //document.querySelectorAll('.block').forEach(block => block.classList.add('shiftKey'))
    }
    
    const onKeyUp = () => {
        if (ctrlKey == false) return;
        setCtrlKey(false)
        if(shiftKey) document.querySelectorAll('.block').forEach(block => block.classList.remove('ctrlKey'))
        //setCtrlKey(false);
        // Messy fix for optimize rendering on block for multiple selection
        //document.querySelectorAll('.block').forEach(block => block.classList.remove('shiftKey'))
    }

    return { onKeyDown, onKeyUp, ctrlKey};
}

export default useCtrlKey;